// export const backendHost = 'http://127.0.0.1:55582';
export const backendHost = window.location.origin;
// export const backendHost = 'https://admin.win777.online';